import { PropsWithChildren } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StripInteractions } from '../../plot/components/StripInteractions';
import { isToolActiveSelector } from '../../tool/selectors/tool.selectors';
import { Tool } from '../../tool/utils/tool.utils';
import { startRuler2d } from '../thunks/start-ruler2d.thunk';
import { setRuler2dTimestamp } from '../thunks/set-ruler2d-timestamp.thunk';
import { setRuler2dVoltage } from '../thunks/set-ruler2d-voltage.thunk';

export const Ruler2dContainer: React.FC<PropsWithChildren> = ({ children }) => {
  const dispatch = useDispatch();
  const isRuler2dActive = useSelector(isToolActiveSelector(Tool.ruler2d));

  const handler = (
    eventType: keyof WindowEventMap,
    timestamp: number,
    voltage: number,
  ) => {
    switch (eventType) {
      case 'mousemove':
        dispatch(setRuler2dTimestamp(timestamp));
        dispatch(setRuler2dVoltage(voltage));
        break;
      case 'mousedown':
        dispatch(startRuler2d(timestamp, voltage));
        break;
    }
  };

  if (!isRuler2dActive) {
    return <></>;
  }

  return (
    <StripInteractions eventHandler={handler}>{children}</StripInteractions>
  );
};
